import {
  IStudentNotification,
  IStudentNotificationUnreadCount,
} from '../../../interfaces/newStudent/notification.interface';
import { defaultReturnNotToast } from '../../../util/newStudent';
import * as apiService from '../../api/newStudent/apiStudent.service';

export const notificationsServiceNewStudent = {
  async show(): Promise<{
    data: IStudentNotification[];
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await apiService.authenticatedRequest(
        '/student/notifications/show',
        'GET',
      );

      return defaultReturnNotToast(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },

  async unreadCount(): Promise<{
    data: IStudentNotificationUnreadCount;
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await apiService.authenticatedRequest(
        '/student/notifications/unread-count',
        'GET',
      );

      return defaultReturnNotToast(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },

  async markAsRead(id: number): Promise<{
    data: boolean;
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await apiService.authenticatedRequest(
        `/student/notifications/mark-as-read/${id}`,
        'POST',
      );

      return defaultReturnNotToast(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },

  async markAllAsRead(): Promise<{
    data: boolean;
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await apiService.authenticatedRequest(
        '/student/notifications/mark-all-as-read',
        'POST',
      );

      return defaultReturnNotToast(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },
};
